import React from 'react';

import { Box, Icon } from '@rbilabs/universal-components';

import { hiddenAccessibilityPlatformProps } from 'utils/accessibility';

import theme from './theme';

export const NextIcon = () => (
  <Box w="16px">
    <Icon variant="next" color={theme.iconContainer.color} {...hiddenAccessibilityPlatformProps} />
  </Box>
);
